<template>
    <div>
        <b-card>
      <b-card-title
        class="fs-32 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center">
          <span> Alteração de Preço Geral </span>
        </div>
      </b-card-title>
      <b-card-text>
        <b-row>
          <b-col>
            <div class="d-flex">
              <b-form-group
                label="Atualizar preço de todos os produtos em porcentagem de uma única vez"
                v-slot="{ ariaDescribedby }"
              >
                <b-form-radio
                class="mt-2"
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="acrescimo">
                    Acrescentar porcentagem do preço geral
                   <div class="input-group mb-3" v-if="selected == 'acrescimo'">
                    <b-input
                      type="number"
                      v-model="percentUp"
                      class="form-control"
                      placeholder="Ex: 99"
                      v-mask="['##']"
                    >
                    </b-input>
                    <div class="input-group-prepend">
                        <span class="input-group-text">%</span>
                    </div>
                  </div>
                </b-form-radio>
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="desconto">
                    Subtrair porcentagem do preço geral
                  <div class="input-group mb-3" v-if="selected == 'desconto'">
                    <b-input
                      type="number"
                      v-model="percentDown"
                      class="form-control text-danger"
                      placeholder="Ex: -99"
                      v-mask="['-##']"
                    ></b-input>
                    <div class="input-group-prepend">
                        <span class="input-group-text">%</span>
                    </div>
                  </div>
                </b-form-radio>
              </b-form-group>

              <div v-if="valuePercent == 0 || valuePercent == '' || valuePercent == null"></div>
              <div class="d-flex align-items-center justify-content-center mt-5" v-else>
                <h1 v-if="valuePercent < 0 || result < 0">
                  <i
                    class="fas fa-long-arrow-alt-down text-danger"
                  ><h6 class="d-inline">
                    *{{ resultPercent() }} % Subtraído em todos os produtos
                    </h6>
                  </i>
                  </h1>
                <h1 v-else>
                  <i
                    class="fas fa-long-arrow-alt-up text-success"
                  ><h6 class="d-inline">
                    *{{ resultPercent() }} % de Acréscimo em todos os produtos
                    </h6></i>
                </h1>
              </div>

            </div>
          </b-col>
        </b-row>
      </b-card-text>
      <b-card-text>
        <b-button
          variant="success"
          class="button-width"
          @click="savePercent()"
        >Salvar</b-button>
      </b-card-text>
    </b-card>
    </div>
</template>

<script>
import makeToast from '@/mixins/makeToast';
import { mapActions, mapState } from 'vuex';
export default {
  mixins: [makeToast],
  emit: ['pageReload'],
  data() {
    return {
      percentUp: '',
      percentDown: '',
      selected: '',
      valuePercent: '',
      result: 0,
    }
  },

  mounted() {
    this.get();
  },

  computed: {
    ...mapState(['dadosUsuario']),
    ...mapActions('shopkeeper', [
      'getPercent',
    ]),
  },

  methods: {
    get() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getPercent', this.dadosUsuario.id)
        .then((resp) => {
         this.valuePercent = resp.data.percentage;
        })
        .catch(() => {
          this.makeToast('Opss!', 'Houve um erro ao atualizar!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },

    resultPercent() {
      if (this.selected == 'acrescimo') {
        this.percentDown = '';
        this.result = parseInt(this.valuePercent) + parseInt(this.percentUp == '' ? 0 : this.percentUp) ;
      }
       else if (this.selected == 'desconto') {
         this.percentUp = '';
        this.result = parseInt(this.valuePercent) + parseInt(this.percentDown == '' ? 0 : this.percentDown);
      }
      else {
        this.result = parseInt(this.valuePercent);
      }
      return this.result;
    },

    savePercent(){
      const data = {
        construp_user_id: this.dadosUsuario.id,
        percentage: this.percentUp.charAt(0) ? this.percentUp : this.percentDown,
      }
       
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/savePercentAddition', data)
        .then((resp) => {
          if (data.percentage == "") {
            this.makeToast('Opss!',
              'Houve um erro, favor digitar um valor!', 'danger'
            );
            return;
          }
          this.percentUp = '';
          this.percentDown = '';
          this.get();
        })
        .catch(() => {
          this.makeToast('Opss!', 'Houve um erro ao atualizar!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Sucesso', 'Alteração de preço realizada com sucesso!', 'success');
        });
    }
  }
}
</script>
<style scoped>
.button-width {
  width: 100px;
}
</style>